
<style lang='scss'>
</style>

<template>
	<div class="padding-right-20 lookinfo">
		<vForm :label-width="100" ref="form" :model='formData' class="clearfix">
			<vCol span='12'>
				<vFormItem label='店铺' prop='accountId' :rules='required'>
					<Select clearable v-model="formData.accountId" filterable>
						<Option v-for="item in accounts" :value="item.id" :key="item.id">{{ item.title }}({{ item.flag }})</Option>
					</Select>
				</vFormItem>
			</vCol>
			<vCol span='12' :key="formData.sellerSku">
				<vFormItem label='Seller SKU' prop='sellerSku' :rules='required'>
					<Select clearable v-model="formData.sellerSku" filterable @on-query-change="getSellerSku">
						<Option v-for="item in erpSkuList" :value="item.sellerSku" :key="item.sellerSku">{{ item.sellerSku }}</Option>
					</Select>
				</vFormItem>
			</vCol>
			<vCol span='12'>
				<vFormItem label='项目'>
					<span  class="item-content">{{formData.lineId|transferText('name',products)}}</span>
					<!-- <Select clearable v-model="formData.lineId">
						<Option v-for="item in products" :value="item.id" :key="item.id">{{ item.name }}</Option>
					</Select> -->
				</vFormItem>
			</vCol>
			<vCol span='12'>
				<vFormItem label='ERPSKU'>
					<span  class="item-content">{{formData.erpSku}}</span>
					<!-- <Input clearable v-model="formData.erpSku"/> -->
				</vFormItem>
			</vCol>
			<vCol span='12'>
				<vFormItem label='锁定开始时间' :rules='required'  prop='beginDate'>
					 <DatePicker type="date" clearable v-model="formData.beginDate" class="width-100per"/>
					 <span class="color-error">GMT时间 时分秒默认00:00:00</span>
				</vFormItem>
			</vCol>
            <vCol span='12'>
				<vFormItem label='锁定结束时间' :rules='required' prop='endDate'>
					 <DatePicker type="date" clearable v-model="formData.endDate" class="width-100per"/>
					 <span class="color-error">GMT时间 时分秒默认00:00:00</span>
				</vFormItem>
			</vCol>
            <vCol span='12'>
				<vFormItem label='锁定仓库' :rules='required' prop='orgWarehouseId'>
					<Select clearable v-model="formData.orgWarehouseId" filterable>
						<Option v-for="item in warehouses" :value="item.id" :key="item.id">{{ item.title }}({{ item.code }})</Option>
					</Select>
				</vFormItem>
			</vCol>
            <vCol span='12'>
				<vFormItem label='锁定数量' :rules='required' prop='quantity'>
					<InputNumber :min="1" clearable v-model="formData.quantity" class="width-100per"/>
				</vFormItem>
			</vCol>
             <vCol span='12' :rules='required'>
				<vFormItem label='状态'>
					<Select v-model="formData.status">
						<Option value="ACTIVATE">激活</Option>
						<Option value="DRAFT">草稿</Option>
					</Select>
					<span class="color-error">激活后系统才会进行自动锁定</span>
				</vFormItem>
			</vCol>
            <vCol span='12'>
				<vFormItem label='锁定原因' :rules='required' prop='reasonType'>
					<Select  v-model="formData.reasonType">
						<Option :value="2">超期备货</Option>
						<Option :value="1">新品锁定</Option>
						<Option :value="3">爆款备货</Option>
						<Option :value="4">促销锁定</Option>
						<Option :value="5">其它</Option>
					</Select>
				</vFormItem>
			</vCol>
            <vCol span='24'>
				<vFormItem label='备注'>
					<Input clearable v-model="formData.remark" type="textarea" :rows="4"/>
				</vFormItem>
			</vCol>
		</vForm>
		<footer class="text-right">
			<Button type="primary" @click="submit">提交</Button>
			<Button class="margin-left-10" @click="cancel">取消</Button>
		</footer>
		<Spin size="large" fix v-if="loading"></Spin>
	</div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { HttpUpdateSaLock, HttpSaLock, HttpSellerSku } from '@/service/boss/allot';


export default {
	props: ['id', 'type'],
	data() {
		return {
			loading: false,
			erpSkuList: [],
			formData: {
				orgId: global.SYSID,
				accountId: '',
				lineId: '',
				sellerSku: '',
				erpSku: '',
				beginDate: '',
				endDate: '',
				orgWarehouseId: '',
				remark: '',
				status: 'ACTIVATE',
				reasonType: '',
				quantity: 1,
			},
			required: [{
				required: true,
				message: "该信息不能为空,请填写"
			}],
		};
	},
	mounted() {
		this.getDetail();
	},
	watch: {
		"formData.sellerSku": function (val) {
			if (!val) return;
			const data = this.erpSkuList.filter(item => {
				return item.sellerSku === val
			})[0];
			if (data) {
				this.formData.lineId = data.lineId;
				this.formData.erpSku = data.erpSku;
			}
		},
		"formData.accountId": function (val) {
			this.erpSkuList = [];
			this.formData.sellerSku = "";
			this.formData.lineId = "";
			this.formData.erpSku = "";
			if (val) {
				this.getSellerSku('', this.accountflag)
			}
		}
	},
	computed: {
		...mapState('boss',['products', 'accounts']),
		...mapGetters('boss', ['warehouses']),
		accountflag() {
			const id = this.formData.accountId,
				data = this.accounts.filter(item => {
					return item.id == id
				})[0] || {};
			return data.flag;
		},
	},
	methods: {
		cancel() {
			this.$emit('on-close');
		},

		async getDetail() {
			if (this.type !== 'edit') return false;
			this.loading = true;
			HttpSaLock({
				id: this.id
			}).then(res => {
				const { accountFlag, accountId, orgId, lineId, sellerSku, erpSku, beginDate, endDate, orgWarehouseId, remark, status = 'ACTIVATE', reasonType, quantity = 1 } = res.data;
				this.formData = Object.assign(this.formData, { orgId, accountId });
				this.$nextTick(() => {
					this.getSellerSku(erpSku, accountFlag).finally(result => {
						this.formData = Object.assign(this.formData, { id: this.id, lineId, sellerSku, erpSku, beginDate, endDate, orgWarehouseId, remark, status, reasonType, quantity })
					});
				})
				this.loading = false;
			}, err => {
				this.errorMessage(err.message);
				this.loading = false;
			});
		},
		async getSellerSku(query = "", flag) {
			flag = flag || this.accountflag;
			if (!flag) {
				this.$Message.warning("请选择店铺");
				return;
			}
			return HttpSellerSku({
				page: 1,
				rows: 10,
				sidx: 'id',
				sord: 'desc', search: {
					EQ_accountFlag: flag,
					CN_sellerSku: query,
				}
			}).then(res => {
				this.erpSkuList = res.data.content;
			})
		},
		async submit() {
			let valid = await this.$refs['form'].validate();
			if (!valid) return;
			this.loading = true;
			const formdata = { ...this.formData };
				if (formdata.status == 'ACTIVATE') {
            				formdata.status = 1;
            			}else{
            			formdata.status = 0;
            			}
			formdata.beginDate = this.handleDateFormat(formdata.beginDate, 'yyyy-mm-dd');
			formdata.endDate = this.handleDateFormat(formdata.endDate, 'yyyy-mm-dd');
			HttpUpdateSaLock(formdata).then(res => {
				this.$Message.success(res.message);
				this.cancel();
				this.$emit('on-update');
				this.loading = false;
			}, err => {
				this.errorMessage(err.message);
				this.loading = false;
			});
		}
	},

};
</script>



